import React, { useState } from 'react';
import propTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import { connect } from 'react-redux';
import { updateList } from '~/Redux/Modules/UserLists';
import PlusIcon from '~/Components/Global/Assets/PlusIcon';
import { createFolder } from '~/Redux/Modules/Folders';
import Button from '~/Components/Global/Form/Button';
import FolderOption from './FolderOption';

const FolderModal = props => {
  const { userFolders, listToMove, setShowModal, dispatchUpdateList, dispatchCreateFolder } = props;
  const [selectedFolder, setSelectedFolder] = useState();
  const [activeFolderId, setActiveFolderId] = useState(listToMove.list_group_id);
  const [checked, setChecked] = useState(false);
  const [noFolderOptionChecked, setNoFolderOptionChecked] = useState(false);
  const [createNewFolder, setCreateNewFolder] = useState(false);
  const [newFolder, setNewFolder] = useState('');

  const moveHandler = () => {
    if (noFolderOptionChecked) {
      dispatchUpdateList({ ...listToMove, list_group_id: null });
    } else {
      dispatchUpdateList({ ...listToMove, list_group_id: selectedFolder.id });
    }
    setShowModal(false);
  };

  const cancelHandler = () => {
    setSelectedFolder([]);
    setShowModal(false);
  };

  const onSelectFolder = folder => {
    if (noFolderOptionChecked) setNoFolderOptionChecked(false);
    setActiveFolderId(folder.id);
    let tempSelectedFolder = folder;
    setSelectedFolder(tempSelectedFolder);
  };

  const toggleCreate = () => {
    setCreateNewFolder(true);
  };

  const handleKeyDown = event => {
    if (event.keyCode === 13) {
      event.preventDefault();
      if (newFolder.trim() !== '') {
        handleCreateNewFolder(newFolder);
      }
    }
  };
  const handleCreateNewFolder = folder => {
    dispatchCreateFolder({ title: folder });
    setNewFolder('');
    setCreateNewFolder(false);
  };

  const clickNoFolderHandler = () => {
    if (activeFolderId !== null) {
      setNoFolderOptionChecked(current => !current);
      setActiveFolderId(null);
      setChecked(true);
    }
  };
  return (
    <div className="folder-modal-overlay do-not-close-dropdown">
      <div className="folder-modal-content">
        <span className="modal-title">Choose a folder for &quot;{listToMove.title}&quot;</span>
        {userFolders.length >= 1 ? (
          <div className="folder-modal-list">
            <div className="modal-scrollable">
              {listToMove.list_group_id !== null && (
                <div
                  role="button"
                  tabIndex="0"
                  className={`folder-modal-option ${
                    noFolderOptionChecked ? 'no-folder-checked' : ''
                  }`}
                  onClick={() => clickNoFolderHandler()}
                >
                  <span className="folder-modal-option-title">No Folder</span>
                  <FontAwesome
                    className={`folder-check ${noFolderOptionChecked ? 'complete' : 'incomplete'}`}
                    name="check-circle"
                  />
                </div>
              )}
              {userFolders.map(folder => {
                return (
                  <FolderOption
                    key={folder.id}
                    className={folder.id === activeFolderId ? 'active-modal-folder' : null}
                    setChecked={setChecked}
                    onSelectFolder={onSelectFolder}
                    folder={folder}
                    setActiveFolderId={setActiveFolderId}
                    activeFolderId={activeFolderId}
                  />
                );
              })}
            </div>
            {createNewFolder && (
              <input
                autoFocus
                onKeyDown={handleKeyDown}
                value={newFolder}
                name="newFolder"
                placeholder="My New Folder"
                className="new-folder-input"
                onChange={e => setNewFolder(e.target.value)}
                onBlur={e => toggleCreate(e)}
              />
            )}
            <div
              onClick={e => toggleCreate(e)}
              className={` ${createNewFolder ? 'hide-new-folder' : 'new-folder-modal'}`}
            >
              <PlusIcon className="new-folder-modal-plus-icon" /> <span>New Folder</span>
            </div>
            <div className="folder-modal-buttons">
              <span
                role="button"
                tabIndex="0"
                onClick={() => cancelHandler()}
                className="modal-cancel do-not-close-dropdown"
              >
                Cancel
              </span>
              {
                <Button
                  onClick={() => {
                    checked ? moveHandler() : null;
                  }}
                  text="Move"
                  className={`do-not-close-dropdown pill modal-move-button ${
                    checked ? 'checked' : ''
                  }`}
                  type="submit"
                />
              }
            </div>
          </div>
        ) : (
          <>
            <span className="empty-folder-modal">Create a folder to get started!</span>
            <span role="button" tabIndex="0" onClick={() => cancelHandler()} className="modal-exit">
              Exit
            </span>
          </>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => {
  return {
    dispatchUpdateList: data => dispatch(updateList(data)),
    dispatchCreateFolder: data => dispatch(createFolder(data)),
  };
};

FolderModal.propTypes = {
  userFolders: propTypes.array,
  listToMove: propTypes.object,
  setShowModal: propTypes.func,
  dispatchUpdateList: propTypes.func,
  dispatchCreateFolder: propTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(FolderModal);
